import { Layer } from 'yeself-common/typings/guide/Layer';

export const omitGuidesByLayerType = (guides: Layer[], types: string[]) => guides.filter(guide => !types.includes(guide.type));